import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/salesData';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-16 px-4 bg-surface-light" data-id="element-60" data-mp="1bmvduyo2iarr">
      <div className="max-w-3xl mx-auto" data-id="element-61" data-mp="1gkepdqtds9g0">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-62" data-mp="1glgc4sjrekdk">
          <h2 className="text-3xl md:text-4xl font-bold text-primary" data-id="element-63" data-mp="1uhabokyn7xe0">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-64" data-mp="2n7il9of459gz">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="border border-primary/10 rounded-xl overflow-hidden bg-white" data-id="element-65" data-mp="2rys8yjh3q2q8" data-mpi={index}>
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-white transition-colors" data-id="element-66" data-mp="19skam41xal2v">
                <span className="font-semibold text-gray-900 pr-4" data-id="element-67" data-mp="1xk7tpzsy0rul">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-gray-500 flex-shrink-0 transition-transform ${openIndex === index ? 'transform rotate-180' : ''}`} data-id="element-68" data-mp="1slecpxeg6ipo" />
              </button>

              <AnimatePresence data-id="element-69" data-mp="3ue2iadekdi8m">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden bg-white" data-id="element-70" data-mp="1yaekmeb6220e">
                    <div className="p-6 pt-4 text-gray-700 border-t border-gray-100" data-id="element-71" data-mp="2qx8tedymfcy1">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}